import api from 'services/api';

class UserService {
  // Listar usuários
  async getUsers() {
    try {
      const response = await api.get('/users');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
      throw error;
    }
  }

  // Buscar usuário por ID
  async getUser(id) {
    try {
      const response = await api.get(`/users/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar usuário:', error);
      throw error;
    }
  }

  // Criar usuário
  async createUser(userData) {
    try {
      const response = await api.post('/users', userData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar usuário:', error);
      throw error;
    }
  }

  // Atualizar usuário
  /**
   * O próprio perfil e a própria senha. Não levam `id`: o backend edita quem está logado, e é por
   * isso que não exigem permissão de administração. `updateUser` é a rota do administrador.
   */
  async updateMe(dados) {
    const response = await api.put('/users/me', dados);
    return response.data;
  }

  async updateMyPassword(dados) {
    const response = await api.put('/users/me/password', dados);
    return response.data;
  }

  async updateUser(id, userData) {
    try {
      const response = await api.put(`/users/${id}`, userData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar usuário:', error);
      throw error;
    }
  }

  // Excluir usuário
  async deleteUser(id) {
    try {
      const response = await api.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao excluir usuário:', error);
      throw error;
    }
  }

  // Buscar permissões do usuário
  async getUserPermissions(id) {
    try {
      const response = await api.get(`/users/${id}/permissions`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar permissões do usuário:', error);
      throw error;
    }
  }

  // Sincronizar permissões do usuário
  async syncUserPermissions(id, permissions) {
    try {
      const response = await api.post(`/users/${id}/permissions`, {
        permissions: permissions
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao sincronizar permissões:', error);
      throw error;
    }
  }

  // Aplicar preset de permissões
  async applyPreset(id, presetName) {
    try {
      const response = await api.post(`/users/${id}/apply-preset`, {
        preset_name: presetName
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao aplicar preset:', error);
      throw error;
    }
  }
}

const userService = new UserService();
export default userService;

